import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../../../utils/lazyImportRouteComponent"

export const Route = createFileRoute(
  "/app/my/absences/successfully-send"
)({
  validateSearch: (search) => ({
    id: typeof search["id"] === "string" ? (search["id"] as string) : null,
  }),
  component: lazyImportRouteComponent(
    () => import("./-components/SuccessPage"),
    "SuccessPage"
  ),
})
